// Half a cent: the boundary at which roundToCents turns a balance into a whole cent owed.
export const OWED_BALANCE_FROM = '0.005';
//# sourceMappingURL=owed-balance-from.js.map